import React from 'react';
import ChoiceWithTextQuestionEditor, { Props as EditorProps } from './ChoiceWithTextQuestionEditor';
import ChoiceWithTextQuestionInput, { Props as InputProps } from './ChoiceWithTextQuestionInput';

type EditProps = EditorProps & {
  mode: 'edit';
}

type ViewProps = Pick<InputProps, 'question' | 'expand'> & {
  mode: 'view';
  deprecated?: boolean;
};

type SubmitProps = InputProps & {
  mode: 'submit';
}

type Props = EditProps | ViewProps | SubmitProps;

const ChoiceWithTextQuestion: React.FC<Props> = (props: Props) => {
  const { mode } = props;

  if (mode === 'edit') {
    const {
      surveyId,
      sectionId,
      addQuestion,
      question,
      onCancelEdit,
      updateQuestion,
    } = props as EditProps;
    return (
      <ChoiceWithTextQuestionEditor
        surveyId={surveyId}
        sectionId={sectionId}
        question={question}
        addQuestion={addQuestion}
        updateQuestion={updateQuestion}
        onCancelEdit={onCancelEdit}
      />
    );
  }

  if (mode === 'view') {
    const {
      question,
      expand,
      deprecated,
    } = props as ViewProps;
    return (
      <ChoiceWithTextQuestionInput
        deprecated={deprecated}
        question={question}
        disabled={false}
        expand={expand}
      />
    );
  }

  if (mode === 'submit') {
    const {
      caseId,
      sectionId,
      enrollmentId,
      disabled,
      defaultSubmission,
      question,
      onSave,
      summarizedView,
    } = props as SubmitProps;
    return (
      <ChoiceWithTextQuestionInput
        question={question}
        caseId={caseId}
        sectionId={sectionId}
        enrollmentId={enrollmentId}
        disabled={disabled}
        onSave={onSave}
        defaultSubmission={defaultSubmission}
        summarizedView={summarizedView}
      />
    );
  }

  return null;
};

export default ChoiceWithTextQuestion;
